import { render } from "./MasterDataColumnsView.vue?vue&type=template&id=be5424e8&scoped=true&ts=true"
import script from "./MasterDataColumnsView.vue?vue&type=script&lang=ts"
export * from "./MasterDataColumnsView.vue?vue&type=script&lang=ts"

import "./MasterDataColumnsView.vue?vue&type=style&index=0&id=be5424e8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be5424e8"]])

export default __exports__